
import { Button } from "@/components/ui/button";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { KeyRound } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function SecuritySection() {
  const navigate = useNavigate();
  
  return (
    <>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <KeyRound className="h-5 w-5" />
          Security
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Button
          variant="outline"
          className="w-full"
          onClick={() => navigate("/auth/update-password")}
        >
          Change Password
        </Button>
      </CardContent>
    </>
  );
}
